export const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export class Endpoints {
  // MERCHANT SERVICE
  static signup = API_BASE_URL + "/auth/signup";
  static verifyEmail = API_BASE_URL + "/auth/verify-email";
  static resendVerifyEmail = (email: string) =>
    API_BASE_URL + `/auth/resend-verification-email/${email}`;
  static login = API_BASE_URL + "/auth/login";
  static requestPasswordReset = API_BASE_URL + "/auth/request-password";
  static resetPassword = API_BASE_URL + "/auth/reset-password";
  static profile = API_BASE_URL + "/merchant/profile";
  static roles = API_BASE_URL + "/merchant/roles";
  static getTeamMember = API_BASE_URL + "/team/members";
  static inviteTeam = API_BASE_URL + "/team/members/invite";
  static acceptTeam = API_BASE_URL + "/team/invite/accept";
  static changeTeamRole = API_BASE_URL + "/team/role/";
  static enforce2fa = API_BASE_URL + "/team/enfore-2fa";
  static cancelTeamInvite = API_BASE_URL + "/team/invite/cancel";
  static removeTeamMember = (memberId: string) =>
    API_BASE_URL + `/team/members/${memberId}`;
  static changePassword = API_BASE_URL + "/merchant/password";
  static enableMfa = API_BASE_URL + "/two-factor-auth/enable";
  static disableMfa = API_BASE_URL + "/two-factor-auth/disable";
  static completeMfa = (token: string) =>
    API_BASE_URL + `/two-factor-auth/complete/${token}`;
  static verifyMfaToken = (token: string) =>
    API_BASE_URL + `/two-factor-auth/verify/${token}`;
  static merchantContacts = API_BASE_URL + "/merchant/contacts";
  static updateMerchantPreference = API_BASE_URL + "/merchant/business";
  static updateDomain = API_BASE_URL + "/merchant/domain";
  static setApiKey = API_BASE_URL + "/merchant/set-api-key";
  static generateApiKey = API_BASE_URL + "/merchant/generate-api-key";
  static setIpWhiteList = API_BASE_URL + "/merchant/whitelist";
  static createSubaccounts = API_BASE_URL + "/subaccounts/create";
  static subaccounts = API_BASE_URL + "/subaccounts";
  static deleteSubaccounts = (id: string) =>
    API_BASE_URL + `/subaccounts/${id}`;
  static updateSubaccounts = (id: string) =>
    API_BASE_URL + `/subaccounts/${id}`;
  static getSubaccountShare = API_BASE_URL + "/subaccounts/current-share";
  static getAllStores = API_BASE_URL + "/store/create";
  static getStore = (id: string) => API_BASE_URL + `/store/${id}`;
  static deleteStore = (id: string) => API_BASE_URL + `/store/${id}`;
  static createMerchantAccount = API_BASE_URL + "/dashboard/accounts/create";
  static merchantAccounts = API_BASE_URL + "/dashboard/accounts";
  static merchantAccount = (id: string) =>
    API_BASE_URL + `/dashboard/accounts/${id}`;
  static updateMerchantAccountType = (id: string) =>
    API_BASE_URL + `/dashboard/accounts/${id}/type`;
  static onboardingStatus = API_BASE_URL + "/onboarding/status";
  static onboardingBegin = API_BASE_URL + "/onboarding/begin";
  static onboardingInfo = API_BASE_URL + "/onboarding/info";
  static onboardingRegistration = API_BASE_URL + "/onboarding/registration";
  static onboardingShareholder = API_BASE_URL + "/onboarding/shareholder";
  static onboardingStructure = API_BASE_URL + "/onboarding/structure";
  static onboardingAccount = API_BASE_URL + "/onboarding/account";
  static createStore = API_BASE_URL + "/store/create";
  static getStores = API_BASE_URL + "/store";
  static updateStore = (id: string) => API_BASE_URL + `/store/${id}/update`;
  static updateStoreStatus = (id: string) =>
    API_BASE_URL + `/store/${id}/state`;
  static store = (id: string) => API_BASE_URL + `/store/${id}`;
  static duplicateStore = (id: string) =>
    API_BASE_URL + `/store/duplicate/${id}`;
  static getProducts = (storeId: string) =>
    API_BASE_URL + `/store/${storeId}/products`;
  static createProducts = API_BASE_URL + `/products/create`;
  static deleteProduct = (productId: string) =>
    API_BASE_URL + `/products/${productId}`;
  static getProduct = (productId: string) =>
    API_BASE_URL + `/products/${productId}/details`;
  static duplicateProduct = (productId: string) =>
    API_BASE_URL + `/products/${productId}/duplicate`;
  static updateProduct = (productId: string) =>
    API_BASE_URL + `/products/${productId}/update`;
  static addDeliveryLocation = (productId: string) =>
    API_BASE_URL + `/products/${productId}/delivery`;
  static updateDeliveryLocation = (locationId: string) =>
    API_BASE_URL + `/products/${locationId}/update-delivery-info`;
  static deleteDeliveryLocation = (locationId: string) =>
    API_BASE_URL + `/products/${locationId}/delete-delivery-info`;
  static getOrders = API_BASE_URL + "/orders";
  static getOrder = (id: string) => API_BASE_URL + `/orders/${id}`;
  static markOrderDelivered = (id: string) =>
    API_BASE_URL + `/orders/${id}/deliver`;
  static cancelOrder = (id: string) => API_BASE_URL + `/orders/${id}/cancel`;
  static refundOrder = (id: string) => API_BASE_URL + `/orders/${id}/refund`;
  static orderCount = API_BASE_URL + "/orders/count";
  static createDiscount = API_BASE_URL + "/discounts/create";
  static setDiscountState = (discountId: string) =>
    API_BASE_URL + `/discounts/${discountId}/state`;
  static discounts = API_BASE_URL + "/discounts";
  static discount = (discountId: string) =>
    API_BASE_URL + `/discounts/${discountId}`;
  // PAYMENT SERVICE
  static transactions = API_BASE_URL + "/payment/dashboard/transactions";
  static exportTransactions =
    API_BASE_URL + "/payment/dashboard/transactions/export";
  static transaction = (id: string) =>
    API_BASE_URL + `/payment/dashboard/transactions/${id}`;
  static overview = API_BASE_URL + "/payment/dashboard/overview";
  static allTransactions = API_BASE_URL + "/payment/transaction";
  static getCustomers = API_BASE_URL + "/payment/dashboard/customers";
  static createCustomer = API_BASE_URL + "/payment/dashboard/customers/create";
  static customer = (id: string) =>
    API_BASE_URL + `/payment/dashboard/customers/${id}`;
  static blackListCustomer = (id: string) =>
    API_BASE_URL + `/payment/dashboard/customers/${id}/blacklist`;
  static updateCustomer = (id: string) =>
    API_BASE_URL + `/payment/dashboard/customers/${id}/update`;
  static exportCustomer = API_BASE_URL + `/payment/dashboard/customers/export`;
  static banks = API_BASE_URL + "/banks";
  static resolveAccountName = API_BASE_URL + "/payment/resolve";
  static transfers = API_BASE_URL + "/payment/dashboard/transfers";
  static getTransfer = (id: string) =>
    API_BASE_URL + `/payment/dashboard/transfers/${id}/details`;
  static createTransfer =
    API_BASE_URL + "/payment/dashboard/transfers/initialize";
  static getBeneficiary = API_BASE_URL + "/payment/dashboard/beneficiaries";
  static createBeneficiary =
    API_BASE_URL + "/payment/dashboard/beneficiaries/create";
  static beneficiary = (id: string) =>
    API_BASE_URL + `/payment/dashboard/beneficiaries/${id}`;
  static transferFee = API_BASE_URL + "/payment/dashboard/transfers/fee";
  static verifyBvn = API_BASE_URL + "/onboarding/bvn";
  static refunds = API_BASE_URL + "/payment/refunds";
  static refund = (refundId: string) =>
    API_BASE_URL + `/payment/refunds/${refundId}`;
  static chargebacks = API_BASE_URL + "/payment/chargebacks";
  static chargeback = (chargebackId: string) =>
    API_BASE_URL + `/payment/chargebacks/${chargebackId}`;
  static setChargebackStatus = (chargebackId: string) =>
    API_BASE_URL + `/payment/chargebacks/${chargebackId}/state`;
  static uploadChargebackDocument = (chargebackId: string) =>
    API_BASE_URL + `/payment/chargebacks/${chargebackId}/documents`;
  static createPaymentLink = API_BASE_URL + "/payment/links/create";
  static getPaymentLinks = API_BASE_URL + "/payment/links";
  static getPaymentLink = (linkId: string) =>
    API_BASE_URL + `/payment/links/${linkId}`;
  static updatePaymentLink = (linkId: string) =>
    API_BASE_URL + `/payment/links/${linkId}/update`;
  static getPaymentLinkTransactions = (linkId: string) =>
    API_BASE_URL + `/payment/links/${linkId}/transactions`;
  static deletePaymentLink = (linkId: string) =>
    API_BASE_URL + `/payment/links/${linkId}`;
  // FILE SERVICE
  static uploadFile = API_BASE_URL + "/file/upload/public";
  // NOTIFICATION SERVICE
  static createWebhookAndCallBackUrl =
    API_BASE_URL + "/notification/notifications/set-urls";
  static getWebhookAndCallBackUrl =
    API_BASE_URL + "/notification/notifications/urls";
  static auditLogs = API_BASE_URL + "/notification/auditlogs";
  static auditLog = (auditlogId: string) =>
    API_BASE_URL + `/notification/auditlogs/${auditlogId}`;
  static notifications = API_BASE_URL + "/notification/notifications/";
  static notification = (notificationId: string) =>
    API_BASE_URL + `/notification/notifications/${notificationId}`;
  static markNotificationRead = (notificationId: string) =>
    API_BASE_URL + `/notification/notifications/read/${notificationId}`;
}
